<template>
  <a-form-item
    :label="varLabel"
    :label-col="formItemLayout.labelCol"
    :wrapper-col="formItemLayout.wrapperCol"
  >
    <a-input
      :size="size"
      :addonBefore="prefix"
      :disabled="disabled"
      v-decorator="[
                  `${varName}`,
                  { rules: [{ required: varRequired, message: message, type: 'url'}],
                  initialValue: varInitial
                }]"
      placeholder="https://example.com/123"
    >
      <a-icon slot="addonAfter" :type="icon" v-if="icon" />
    </a-input>
    <a-alert
      :message="description"
      type="info"
      showIcon
      style="margin-top:5px;"
      v-if="description"
    />
  </a-form-item>
</template>

<script>
import { formLayoutMixin } from "@/mixins/formLayout";

export default {
  mixins: [formLayoutMixin],
  props: {
    varName: String,
    varLabel: String,
    varInitial: String,
    varRequired: Boolean,
    formLayout: String,
    size: String,
    icon: [String, null],
    prefix: [String, null],
    description: [String, null],
    disabled: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    message() {
      return `Please enter ${this.varLabel.toLowerCase()}`;
    }
  }
};
</script>
